import type { GQLLocale } from 'graphql-ts-types';

import type { GqlValidationRules } from 'common/components/DynamicForm/types';
import { executeQuery } from 'common/gql';
import type {
  GiftCardValidationRulesQuery,
  GiftCardValidationRulesQueryVariables,
} from 'common/gql/generated/schema';
import { combineQueryWithFragments } from 'common/gql/utils/fragments';
import validationRuleAttributes from 'common/hooks/validation-rules/gql/fragment//validationRuleAttributes.gql';
import validationRuleGroupAttributes from 'common/hooks/validation-rules/gql/fragment//validationRuleGroupAttributes.gql';
import baseValidationRuleAttributes from 'common/hooks/validation-rules/gql/fragment/baseValidationRuleAttributes.gql';
import { captureMessage } from 'common/utils/error-reporter';
import giftCardValidationRulesQuery from '../gql/gift-card-validations.gql';

export interface ValidationRules {
  code: GqlValidationRules;
}

export const fetchGiftCardRules = async (locale: GQLLocale) => {
  try {
    const { validationRules } = await executeQuery<
      GiftCardValidationRulesQuery,
      GiftCardValidationRulesQueryVariables
    >({
      query: combineQueryWithFragments(
        giftCardValidationRulesQuery,
        baseValidationRuleAttributes,
        validationRuleAttributes,
        validationRuleGroupAttributes
      ),
      variables: { locale },
    });

    return validationRules.giftCard as ValidationRules;
  } catch (error) {
    captureMessage(`Failed to fetch the gift card form validation rules. ${error}`);
  }
};
